import * as Sentry from "@sentry/react";

const dsn = import.meta.env.VITE_SENTRY_DSN;

if (dsn) {
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_SENTRY_RELEASE || undefined,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    // 10% of transactions in production, 100% in development
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
    // Capture 10% of sessions for replay, 100% on error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    // Strip PII from breadcrumbs and events
    sendDefaultPii: false,
  });
}

export { Sentry };
